import BaseComponent from '../abstracts/BaseComponent';

export default class ViewAllComponent extends BaseComponent {
  get SELECTORS() {
    return {
      triggers: '.js-view-all',
      content: '.js-accordion-content'
    };
  }
  constructor(props) {
    super(props);
    this.viewAllContent();
    this.onResizeWindow();
  }

  viewAllContent() {
    const large = window.matchMedia("(min-width: 1024px)");
    const wrapper = this.$el.previousElementSibling;
    const itemList = wrapper.querySelectorAll('.news-item')
    wrapper.style.height = 'auto';
    const wrapperH = wrapper.offsetHeight;

    if (!large.matches || itemList.length <= 6) {
      this.$el.classList.add('hide');
      return;
    }

    wrapper.style.height = (wrapperH / 2) + (wrapperH / 4) + 'px';

    this.$el.addEventListener("click", function (event) {
      event.preventDefault();
      wrapper.style.height = 'auto';
      this.classList.add('hide');
    });
  }

  onResizeWindow() {
    window.addEventListener('resize', (e) => {
      this.viewAllContent();
    })
  }
}